const NewSignOut = () => {
	
    localStorage.removeItem("state")
    window.location.replace('..');

}
export default NewSignOut;



// WEBPACK FOOTER //
// ./src/components/User/NewSignOut.js